'use client';
import { ComponentProps } from 'react';
import { CategoriesFor } from './categories-for';
import { CategoryItemsFor } from './category-items-for';
import { CustomerNotificationsFor } from './customer-notifications-for';
import { MenuItemsFor } from './menu-items-for';
import { SubCategoriesFor } from './subcategories-for';
import {
    CategoriesData,
    CategoryItemsData,
    CustomerNotificationsData,
    MenuItemsData,
    SubCategoriesData,
    VenuesData,
} from './types';
import { VenuesFor } from './venues-for';

type Props =
    | CategoriesData
    | SubCategoriesData
    | CategoryItemsData
    | VenuesData
    | MenuItemsData
    | CustomerNotificationsData;

export const For = ({ data, children, ...props }: Props) => {
    const type = typeof data === 'string' ? data : data.type;
    const dataObject =
        typeof data === 'string' ? undefined : (data as { filter?: unknown; filters?: unknown });
    const filters: unknown =
        typeof data === 'string'
            ? (props as { filters?: unknown }).filters
            : (dataObject?.filter ?? dataObject?.filters);

    switch (type) {
        case 'categories': {
            return (
                <CategoriesFor
                    {...(props as Omit<CategoriesData, 'data'>)}
                    filters={filters as ComponentProps<typeof CategoriesFor>['filters']}
                >
                    {children}
                </CategoriesFor>
            );
        }
        case 'subcategories': {
            return (
                <SubCategoriesFor filters={filters as ComponentProps<typeof SubCategoriesFor>['filters']}>
                    {children}
                </SubCategoriesFor>
            );
        }
        case 'categoryItems': {
            return <CategoryItemsFor {...(props as CategoryItemsData)}>{children}</CategoryItemsFor>;
        }
        case 'venues': {
            return (
                <VenuesFor filters={filters as ComponentProps<typeof VenuesFor>['filters']}>
                    {children}
                </VenuesFor>
            );
        }
        case 'menuItems': {
            return (
                <MenuItemsFor
                    {...(props as Omit<MenuItemsData, 'data'>)}
                    filters={filters as ComponentProps<typeof MenuItemsFor>['filters']}
                >
                    {children}
                </MenuItemsFor>
            );
        }
        case 'customerNotifications': {
            return (
                <CustomerNotificationsFor
                    filters={filters as ComponentProps<typeof CustomerNotificationsFor>['filters']}
                >
                    {children}
                </CustomerNotificationsFor>
            );
        }
        default:
            return null;
    }
};
